import { render } from "./AddRemoveTag.vue?vue&type=template&id=cfa15748"
import script from "./AddRemoveTag.vue?vue&type=script&lang=js"
export * from "./AddRemoveTag.vue?vue&type=script&lang=js"
script.render = render

export default script